import type { DataSourceMode } from './DataBridge';

const STORAGE_KEY = 'aees:data-source-mode:v1';
const VALID_MODES: DataSourceMode[] = ['historical', 'live', 'simulation', 'energyplus'];

const validMode = (value: string | null): value is DataSourceMode => (
  Boolean(value) && VALID_MODES.includes(value as DataSourceMode)
);

export function getPreferredDataSourceMode(): DataSourceMode {
  if (typeof window === 'undefined') return 'historical';
  const query = new URLSearchParams(window.location.search).get('source');
  if (validMode(query)) return query;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return validMode(stored) ? stored : 'historical';
  } catch {
    return 'historical';
  }
}

export function setPreferredDataSourceMode(mode: DataSourceMode) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, mode);
  window.dispatchEvent(new CustomEvent('aees:data-source-preference', { detail: { mode } }));
}

export { STORAGE_KEY as DATA_SOURCE_STORAGE_KEY };
